import { useState } from "react";
import { useAuth } from "../../../../hooks/AuthContext";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ButtonVoltar from "../../../../components/Botoes/ButtonVoltar";
import DadosBasicos from "../../../../components/Cadastro/DadosBasicos";
import { ButtonCustom } from "../../../../components/Botoes/Button";
import { saveDadosBasicos } from "../../../../api/Cadastro";
import useAlert from "../../../../hooks/useAlert";
import useStyles from "./styles";
import { Box } from "@mui/material";
import { Titulo } from "../../../../components";

const DadosPessoais = ({ handlerCancelEdit }) => {
  const { user } = useAuth();
  const classes = useStyles();
  const { showAlertSuccess, showAlertError } = useAlert();
  const [dadosCliente, setDadosCliente] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});

  const handlerSubimit = async () => {
    try {
      setIsLoading(true);
      const response = await saveDadosBasicos(
        dadosCliente,
        user.idPerfilLimiteOperacional,
        user.id,
        true
      );

      if (response.errorMessage && response.errorMessage.length > 0) {
        if (response?.fieldErrors) {
          setFieldErrors(response.fieldErrors || {});
        }

        showAlertError(response.errorMessage);
      } else {
        showAlertSuccess("Alteração salva com sucesso!");
      }
      setIsLoading(false);
    } catch (error) {
      showAlertError(error.message);
    }
  };

  return (
    <Box className={classes.root}>
      <Grid container className={classes.container}>
        {/* Cabeçalho */}
        <Grid item xs={12} className={classes.header}>
          <Box display="flex" alignItems="center" mb={2}>
            <ButtonVoltar handleVoltar={handlerCancelEdit} mostraTexto={true} />
          </Box>
          <Titulo variant="h5" className={classes.title}>
            Meus dados
          </Titulo>
        </Grid>

        <Grid item xs={12}>
          <Grid lg={12} item>
            <DadosBasicos
              fieldErrors={fieldErrors}
              idCliente={user.id}
              idPerfilLimiteOperacional={user.idPerfilLimiteOperacional}
              setDada={setDadosCliente}
              isLoading={isLoading}
            />
          </Grid>

          <Grid className={classes.Salvar} lg={12} item>
            <ButtonCustom
              typeButton="primary"
              variant="contained"
              size="medium"
              loading={isLoading}
              onClick={handlerSubimit}
            >
              Salvar alterações
            </ButtonCustom>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
export default DadosPessoais;
